import jsBridge, { init } from './ctx/js-bridge';

// 获取用户登录信息
export default function getAccessToken() {
	return new Promise((resolve, reject) => {
		// 等待 socket 联通
		init(() => {
			jsBridge.getAccessToken({
				type: 'B',
				callback: ({ phone_token }) => {
					resolve(phone_token);
				}
			});
		});
	});
}
